var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-align-center"},[_c('div',{staticStyle:{"margin":"15px auto 0","text-aligin":"center","color":"#6C7D8F"}},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }